import * as angular from 'angular';
import EditJobName, {openEditJob} from "./jobEditor.controller";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import UIUtilityServiceName, {UIUtilityService} from "../../services/utility/uiUtility.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import JobServiceName, {JobService} from "../../services/jobs/job.service";
import NotifyServiceName,  {NotifyService} from "../../services/notify/notify.service";
import {States} from "../../shared/config/constant.module";
import template from './jobList.tpl.html';
import * as _ from "lodash";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";

let requires = [EditJobName, UIUtilityServiceName, LoaderServiceName, JobServiceName, NotifyServiceName, AuthDataServiceName];

interface JobListController {
  jobs: apsViewModels.JobItem[];
  isAdmin: boolean;
  addJob: () => void;
  editJob: (job: apsViewModels.JobItem) => void;
  deleteJob: (job: apsViewModels.JobItem) => void;
}

class JobListCtlr implements  JobListController {
  public filter: string;
  public jobs: apsViewModels.JobItem[];
  private $modal: mm.foundation.modal;
  private jobService: JobService;
  private loaderService: LoaderService;
  private uiUtilityService: UIUtilityService;
  private notifyService: NotifyService;
  private authDataService: AuthDataService;
  isAdmin: boolean;

  constructor ($modal: mm.foundation.modal,
               jobService: JobService,
               loaderService: LoaderService,
               uiUtilityService: UIUtilityService,
               authDataService: AuthDataService,
               notifyService: NotifyService,) {
    this.$modal = $modal;
    this.jobService = jobService;
    this.loaderService = loaderService;
    this.uiUtilityService = uiUtilityService;
    this.notifyService = notifyService;
    this.authDataService = authDataService;
    this.isAdmin = false;
    if (_.find(this.authDataService.getRoles(), x => x.roleName === 'APSIO Administrator')) {
      this.isAdmin = true;
    }
    loaderService.loadingPromise(
      jobService.getJobs().then((jobData) => {
        this.jobs = jobData;
      }, notifyService.handleApiErrors));

  }

  private loadModalJobEditor(job?: apsViewModels.JobItem): void  {
    let result = openEditJob(job, this.$modal);

    result.then(
      (editedJob) => {
        if (!editedJob) {
          return;
        }
        if (job) {
          _.assign(job, editedJob);
          return;
        }
        this.jobs.unshift(editedJob);
      }
    );
  }

  addJob() {
    this.loadModalJobEditor();
  }

  editJob(job: apsViewModels.JobItem) {
    this.loadModalJobEditor(job);
  }

  deleteJob(job: apsViewModels.JobItem) {

    this.uiUtilityService.confirm('Mark ' + job.name + ' as deleted?')
      .then((result) => {
        if (!result) {
          return;
        }
        this.loaderService.loadingPromise(
          this.jobService.deleteJob(job).then(() => {
            _.remove(this.jobs, {id: job.id});
          }, this.notifyService.handleApiErrors)
        );
      });
  }
}

export default angular.module('aps.controller.joblist', requires)
  .config(jobListRoute)
  .controller('JobListCtrl', JobListCtlr)
  .name;

function jobListRoute($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.JOBS,
    url: '/admin/jobs',
    controller: 'JobListCtrl as vm',
    template: template,
    data: {
      pageTitle: 'Jobs',
      authorizePlantAdmin: true,
      v2Uri: "aps/settings/job-list",
    }
  });
}


// WEBPACK FOOTER //
// ./src/app/controllers/job/jobList.controller.ts